import { COLLISION_COLOURS, COLLISION_GROUPS } from '../../../constants/Constants';
import { GameEvents } from '../../GameEvents';
import { CollisionCollider } from '../collisions/CollisionCollider';
import { WorldObject } from './WorldObject';

export class WorldDestructable extends WorldObject {
  constructor(...args) {
    super(...args);

    this.type = 'destructable';
    this.pickup = this.model.pickup;
    this.weapon = this.model.weapon;
    this.coins = this.model.coins;
    this.destroyAnim = this.model.destroyAnim;
    this.health = 3;
    this.canDamage = true;

    const colliderHeight = Math.max(32, this.height);
    const colliderWidth = Math.max(32, this.width);

    if (this.model.damagebox) {
      this._damageCollider = new CollisionCollider(this.scene, {
        x: this.x + this.model.damagebox.x - this.width * 0.5,
        y: this.y - this.height + this.model.damagebox.y,
        width: this.model.damagebox.width,
        height: this.model.damagebox.height,
        sensor: true,
        gameObject: this,
        debugColour: COLLISION_COLOURS.BODY,
        collisionGroup: COLLISION_GROUPS.DESTRUCTIBLE,
        collidesWith: COLLISION_GROUPS.HERO_ATTACK,
      });
    } else {
      this._damageCollider = new CollisionCollider(this.scene, {
        x: this.x - colliderWidth * 0.5,
        y: this.y - colliderHeight,
        sensor: true,
        width: colliderWidth,
        height: colliderHeight,
        gameObject: this,
        debugColour: COLLISION_COLOURS.BODY,
        collisionGroup: COLLISION_GROUPS.DESTRUCTIBLE,
        collidesWith: COLLISION_GROUPS.HERO_ATTACK,
      });
    }
  }

  damage(value) {
    this.health--;
    if (this.health > 0) {
      this.scene.tweens.add({
        targets: this,
        x: '+=10',
        duration: 10,
        repeat: 2,
        yoyo: true,
      });
      this.scene.game.soundController.playSFX('sfx', 'rock_hit');
    } else {
      this.canDamage = false;
      this.scene.tweens.killTweensOf(this);
      this.scene.events.emit(GameEvents.DESTROYED_OBJECT, this);
      this.scene.game.soundController.playSFX('sfx', 'rock_break');
      this.destroy();
    }
  }

  destroy() {
    this._damageCollider.destroy();
    this._damageCollider = null;
    super.destroy();
  }
}
